import { EventEmitter } from "@angular/core";

export class HeaderDelegateRight {
    id: number;
    name: string;
    desc: string;
    visibility: any;
    visibilityTo: any;
    listVisibility: any[];
    listVisibilityTo: any[];
    userListUsed: any[];
    groupListUsed: any[];
    userListUsedTo: any[];
    groupListUsedTo: any[];    

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.id = 0;
        this.name = '';
        this.desc = '';
        this.visibility = null;
        this.visibilityTo = null;
        this.listVisibility = [];
        this.listVisibilityTo = [];
        this.userListUsed = [];
        this.groupListUsed = [];
        this.userListUsedTo = [];
        this.groupListUsedTo = [];        
    }
    public loadVisibility(atype, avisibility) {
        for (let i = 0; i < avisibility.length; i++) {
            this.listVisibility.push({
                label: avisibility[i].name,
                value: { id: avisibility[i].id, name: avisibility[i].name },
            });
            this.listVisibilityTo.push({
                label: avisibility[i].name,
                value: { id: avisibility[i].id, name: avisibility[i].name },
            });            
        }
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.desc = adata.description;
        this.visibility = adata.visibility;
        this.visibilityTo = adata.visibilityto === null ? 0 : adata.visibilityto;
        if (this.visibility === 1) {
            this.groupListUsed = [...this.getAccessList(adata, 0)];
        }
        if (this.visibility === 2) {
            this.userListUsed = [...this.getAccessList(adata, 0)];
        }
        if (this.visibilityTo === 1) {
            this.groupListUsedTo = [...this.getAccessList(adata, 1)];
        }
        if (this.visibilityTo === 2) {
            this.userListUsedTo = [...this.getAccessList(adata, 1)];
        }    
        this.notifyParent.emit();
    }  

    private getAccessList(adata, aVisibilitytype) {
        let wAccessList = [];
        if (adata.webDelegaterightVisibilities.length > 0) {
            for (let i = 0; i < adata.webDelegaterightVisibilities.length; i++) {
                if (adata.webDelegaterightVisibilities[i].visibilitytype === aVisibilitytype || 
                    adata.webDelegaterightVisibilities[i].visibilitytype === null) {
                    wAccessList.push(adata.webDelegaterightVisibilities[i].name);
                }
            }
        }
        return wAccessList;
    }

}
